import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import html2canvas from 'html2canvas';
import 'moment/locale/es';
import TermAutocomplete from '../../comun/TermAutocomplete';
import { getClinicalTerms } from '../../servicios/apiClinica';

moment.locale('es');
const localizer = momentLocalizer(moment);

/* ─────────────────────────────────────────
   CSS global que sobreescribe react-big-calendar
───────────────────────────────────────── */
const AGENDA_CSS = `
  .rbc-calendar { font-family: 'Inter', 'Segoe UI', sans-serif; }
  .main-agenda-container { max-width: 100vw; overflow-x: hidden; box-sizing: border-box; }

  /* Quitar barra "all day" */
  .rbc-allday-cell { display: none !important; }
  .rbc-time-view .rbc-header.rbc-overflowing { border-right: none !important; }

  /* Cabecera de la grilla */
  .rbc-time-view { border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; }
  .rbc-time-header { background: #f9fafb; border-bottom: 1px solid #e5e7eb !important; }
  .rbc-time-header-content { border-left: 1px solid #e5e7eb !important; }
  .rbc-header { padding: 8px 0 !important; border-left: 1px solid #e5e7eb !important; border-bottom: 0 !important; }
  .rbc-header + .rbc-header { border-left: 1px solid #e5e7eb !important; }

  /* Columna de horas */
  .rbc-time-gutter .rbc-timeslot-group { border-bottom: 1px solid #d1d5db !important; }
  .rbc-label { font-size: 11px; font-weight: 600; color: #6b7280; padding-right: 8px; }

  /* Filas de tiempo */
  .rbc-timeslot-group { border-bottom: 1px solid #d1d5db !important; min-height: 28px; }
  .rbc-day-slot .rbc-time-slot { border-top: 1px solid #e5e7eb !important; }
  .rbc-time-content { border-top: 1px solid #d1d5db !important; }
  .rbc-day-slot { border-left: 1px solid #d1d5db; }

  /* Eventos */
  .rbc-event {
    border: none !important;
    border-radius: 6px !important;
    padding: 4px 8px !important;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;
  }
  .rbc-event.rbc-selected { box-shadow: 0 3px 10px rgba(0,0,0,0.25) !important; }
  .rbc-event-content { font-size: 11px !important; }
  .rbc-event-label { display: none !important; }

  /* Selección */
  .rbc-slot-selection { background: rgba(184, 122, 0, 0.1); border: 1px solid #b87a00; }

  /* Hoy */
  .rbc-today { background-color: rgba(184, 122, 0, 0.04) !important; }

  /* Ocultar toolbar nativa */
  .rbc-toolbar { display: none !important; }
  .btn-configurar-mobile { display: none; }

  /* Botón + en las celdas de tiempo */
  .time-slot-wrapper { position: relative; height: 100%; width: 100%; }
  .add-appointment-btn {
    position: absolute; right: 5px; top: 50%;
    transform: translateY(-50%);
    background: #b87a00; color: white;
    width: 20px; height: 20px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 16px; font-weight: bold; cursor: pointer;
    opacity: 0; transition: opacity 0.2s; z-index: 50;
    border: none; padding: 0; line-height: 1;
  }
  .rbc-time-slot:hover .add-appointment-btn,
  .time-slot-wrapper:hover .add-appointment-btn { opacity: 1; }

  /* Responsividad móvil */
  @media (max-width: 768px) {
    .agenda-header { display: none !important; }
    .agenda-toolbar { flex-direction: column !important; align-items: flex-start !important; gap: 10px; margin-bottom: 10px !important; }
    .agenda-toolbar-left { flex-direction: column; align-items: stretch !important; width: 100%; gap: 10px !important; }
    .agenda-toolbar-left > div { width: 100%; justify-content: center; }
    .agenda-toolbar-right { display: none !important; }
    .rbc-time-view, .rbc-month-view { border-radius: 8px; border: none !important; }
    .btn-nueva-cita { width: 100%; justify-content: center; padding: 12px 14px !important; font-size: 15px !important; margin-top: 10px; }
    .btn-exportar { width: 100%; justify-content: center; padding: 12px 14px !important; font-size: 15px !important; margin-top: 5px; margin-bottom: 5px; display: flex !important; }
    .btn-configurar-mobile { display: flex !important; width: 100%; justify-content: center; padding: 12px 14px !important; font-size: 15px !important; margin-bottom: 5px; }
    .view-buttons { display: flex; width: 100%; }
    .view-buttons > button { flex: 1; text-align: center; justify-content: center; }
    .main-agenda-container { padding: 8px !important; height: calc(100dvh - 60px) !important; overflow: hidden; }
    .agenda-modal-container { border-radius: 12px !important; max-height: 96vh !important; }
    .agenda-modal-header { padding: 12px 16px 8px !important; }
    .agenda-modal-body { padding: 12px 16px !important; }
    .agenda-modal-totales { padding: 0 16px 12px !important; }
    .agenda-modal-footer { padding: 12px 16px !important; }
    .agenda-modal-totales-inner { flex-direction: column !important; align-items: stretch !important; gap: 8px !important; }
    .agenda-modal-totales-left { width: 100%; justify-content: space-between !important; }
    .agenda-modal-totales-right { text-align: left !important; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #e5e7eb; padding-top: 8px; }
    .agenda-modal-container input, .agenda-modal-container select, .agenda-modal-container button { font-size: 13px !important; padding: 4px 8px !important; }
    .agenda-modal-container h3 { font-size: 20px !important; }
    .agenda-modal-container h5 { font-size: 14px !important; }
    .agenda-modal-container th, .agenda-modal-container td { font-size: 12px !important; padding: 4px !important; }
  }
`;

const STATUS_COLORS = {
  scheduled:   '#3b82f6',
  in_progress: '#f59e0b',
  completed:   '#10b981',
  cancelled:   '#ef4444',
};

const STATUS_LABELS = {
  scheduled:   'Programado',
  in_progress: 'En Progreso',
  completed:   'Completado',
  cancelled:   'Cancelado',
};

const API_BASE = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Axios-like fetch wrapper with token
const api = {
  get: async (url) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${API_BASE}${url}`, {
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
    });
    if (!res.ok) throw new Error(`GET ${url} failed`);
    const data = await res.json();
    return { data };
  },
  post: async (url, body) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${API_BASE}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      const err = new Error('POST failed');
      err.response = { data: errData };
      throw err;
    }
    return { data: await res.json() };
  },
  patch: async (url, body) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${API_BASE}${url}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('PATCH failed');
    return { data: await res.json() };
  },
};

/* ─── CustomDayHeader ─── */
const CustomDayHeader = ({ date }) => (
  <div style={{ textAlign: 'center', padding: '8px 0' }}>
    <div style={{ fontSize: '20px', fontWeight: '700', color: '#111827', lineHeight: 1 }}>{moment(date).format('DD')}</div>
    <div style={{ fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: '2px' }}>{moment(date).format('dddd')}</div>
  </div>
);

/* ─── CustomEvent ─── */
const CustomEvent = ({ event }) => {
  const patientName = event.resource?.patient_details?.first_name
    ? `${event.resource.patient_details.first_name} ${event.resource.patient_details.last_name || ''}`.trim().toUpperCase()
    : (event.title || 'PACIENTE').toUpperCase();

  const services = event.resource?.services || [];
  const uniqueDoctors = [];
  const seen = new Set();
  services.forEach(s => {
    const id = s.doctor_details?.id || 'unassigned';
    if (!seen.has(id)) {
      seen.add(id);
      uniqueDoctors.push({ name: s.doctor_details?.first_name || s.doctor_details?.username || 'Sin Asignar', color: s.doctor_details?.color || '#ccc' });
    }
  });

  return (
    <div style={{ lineHeight: '1.15', overflow: 'hidden' }}>
      <div style={{ fontWeight: '800', fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: '#111827' }}>{patientName}</div>
      {uniqueDoctors.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '3px' }}>
          {uniqueDoctors.map((doc, idx) => (
            <div key={idx} style={{ fontSize: '9.5px', fontWeight: '800', color: '#111827', backgroundColor: doc.color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '2px 4px', borderRadius: '4px', display: 'block', width: '100%' }}>{doc.name.toUpperCase()}</div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ─── CustomTimeSlotWrapper ─── */
const CustomTimeSlotWrapper = ({ children, value }) => {
  return React.cloneElement(React.Children.only(children), {
    className: `${children.props.className} time-slot-wrapper`,
    children: (
      <>
        {children.props.children}
        <button 
          className="add-appointment-btn" 
          title="Agregar cita en este horario" 
          onClick={(e) => { 
            e.stopPropagation(); 
            e.preventDefault();
            document.dispatchEvent(new CustomEvent('agenda-add-appointment', { detail: value }));
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            e.preventDefault();
            document.dispatchEvent(new CustomEvent('agenda-add-appointment', { detail: value }));
          }}
        >+</button>
      </>
    )
  });
};

/* ─── YearView ─── */
const YearView = ({ date, onNavigate, onView }) => {
  const currentYear = moment(date).year();
  const months = moment.months();
  return (
    <div style={{ padding: '10px 0', overflowY: 'auto', flex: 1 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '24px' }}>
        {months.map((monthName, i) => {
          const monthDate = moment([currentYear, i, 1]);
          const startDay = (monthDate.day() + 6) % 7;
          const daysInMonth = monthDate.daysInMonth();
          const blanks = Array.from({ length: startDay }, (_, idx) => idx);
          const days = Array.from({ length: daysInMonth }, (_, idx) => idx + 1);
          return (
            <div key={i} style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontSize: '16px', fontWeight: '800', color: '#b87a00', marginBottom: '10px', textTransform: 'capitalize' }}>{monthName}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '3px', textAlign: 'center', fontSize: '12px' }}>
                {['L','M','M','J','V','S','D'].map((d, di) => <div key={di} style={{ color: '#9ca3af', fontWeight: '700', fontSize: '10px' }}>{d}</div>)}
                {blanks.map(b => <div key={`b-${b}`} />)}
                {days.map(d => {
                  const thisDate = moment([currentYear, i, d]);
                  const isToday = thisDate.isSame(moment(), 'day');
                  return (
                    <div key={d} onClick={() => { onNavigate(thisDate.toDate()); onView('day'); }}
                      style={{ padding: '5px 0', cursor: 'pointer', borderRadius: '50%', backgroundColor: isToday ? '#b87a00' : 'transparent', color: isToday ? 'white' : '#374151', fontWeight: isToday ? '800' : '600' }}>
                      {d}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   COMPONENTE PRINCIPAL
═══════════════════════════════════════════ */
const Agenda = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(() => {
    return localStorage.getItem('agendaLastView') || (window.innerWidth <= 768 ? 'day' : 'week');
  });

  useEffect(() => { localStorage.setItem('agendaLastView', currentView); }, [currentView]);

  const [showModal, setShowModal] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState('');
  const [appointmentStartTime, setAppointmentStartTime] = useState('');
  const [appointmentEndTime, setAppointmentEndTime] = useState('');
  const [patients, setPatients] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [patientId, setPatientId] = useState('');
  const [busquedaPaciente, setBusquedaPaciente] = useState('');
  const [mostrarListaPacientes, setMostrarListaPacientes] = useState(false);
  const filteredPatients = patients.filter(p => {
    const term = busquedaPaciente.toLowerCase();
    return `${p.first_name || ''} ${p.last_name || ''}`.toLowerCase().includes(term) || (p.cedula && p.cedula.includes(term)) || (p.phone && p.phone.includes(term));
  }).slice(0, 20);
  const [notes, setNotes] = useState('');
  const [advancePayment, setAdvancePayment] = useState(0);
  const [appointmentServices, setAppointmentServices] = useState([{ id: Date.now(), treatment_id: '', doctor_id: '', notes: '' }]);
  const [serviceSearchQuery, setServiceSearchQuery] = useState('');
  const [cieCodes, setCieCodes] = useState([]);
  const [diagnosisDesc, setDiagnosisDesc] = useState('');
  const [diagnosisCie, setDiagnosisCie] = useState('');
  const [complications, setComplications] = useState('');
  const [prescriptions, setPrescriptions] = useState('');
  const [signatureId, setSignatureId] = useState('');
  const [saving, setSaving] = useState(false);

  // Clinical terms for autocomplete
  const [diagTerms, setDiagTerms] = useState([]);
  const [compTerms, setCompTerms] = useState([]);
  const [prescTerms, setPrescTerms] = useState([]);
  const [procTerms, setProcTerms] = useState([]);

  // Nuevo paciente inline
  const [showNewPatient, setShowNewPatient] = useState(false);
  const [newPatientData, setNewPatientData] = useState({ first_name: '', last_name: '', email: '', phone: '', cedula: '', is_clinical: true });
  const [savingPatient, setSavingPatient] = useState(false);

  // Detalles cita al hacer clic
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const [eventClinicalData, setEventClinicalData] = useState(null);

  useEffect(() => {
    if (selectedEvent && showEventDetails) {
        const patientId = selectedEvent.resource?.patient || selectedEvent.resource?.patient_details?.id;
        if (patientId) {
            api.get(`/api/clinical-records/?patient=${patientId}`)
               .then(res => {
                   let records = res.data?.results || res.data || [];
                   if (Array.isArray(records)) {
                       records = records.filter(r => String(r.patient) === String(patientId) || (r.patient && String(r.patient.id) === String(patientId)));
                   }
                   if (records.length > 0) {
                       let treatmentRow = null;
                       for (const r of records) {
                           const rows = Array.isArray(r.treatments) ? r.treatments : [];
                           treatmentRow = rows.find(t => String(t.appointment_id) === String(selectedEvent.resource.id)) || null;
                           if (treatmentRow) break;
                       }
                       setEventClinicalData(treatmentRow);
                   } else {
                       setEventClinicalData(null);
                   }
               })
               .catch(e => {
                   console.error("Error fetching clinical data for event details", e);
                   setEventClinicalData(null);
               });
        } else {
            setEventClinicalData(null);
        }
    } else {
        setEventClinicalData(null);
    }
  }, [selectedEvent, showEventDetails]);

  // Configuración
  const [showConfig, setShowConfig] = useState(false);
  const [config, setConfig] = useState(() => {
    try { 
      const saved = JSON.parse(localStorage.getItem('agendaConfig'));
      if (saved && saved.visibleDays && saved.visibleDays.length === 5 && saved.startHour === 7) {
        return { startHour: 8, endHour: 20, visibleDays: [0,1,2,3,4,5,6] };
      }
      return saved || { startHour: 8, endHour: 20, visibleDays: [0,1,2,3,4,5,6] };
    } catch { return { startHour: 8, endHour: 20, visibleDays: [0,1,2,3,4,5,6] }; }
  });
  const [tempConfig, setTempConfig] = useState(config);

  /* ── Data fetching ── */
  const fetchAppointments = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/appointments/');
      const data = res.data?.results || res.data || [];
      const now = new Date();
      
      setEvents(data.map(app => {
        const dateStr = app.date || moment().format('YYYY-MM-DD');
        const startStr = app.start_time?.includes('T') ? app.start_time : `${dateStr}T${app.start_time || '08:00:00'}`;
        const endStr = app.end_time?.includes('T') ? app.end_time : `${dateStr}T${app.end_time || '09:00:00'}`;
        
        const startDate = new Date(startStr);
        const endDate = new Date(endStr);

        let status = app.status || 'scheduled';
        if (status !== 'cancelled' && status !== 'completed') {
            if (now >= startDate && now < endDate) {
                status = 'in_progress';
            } else if (now >= endDate) {
                status = 'completed';
            } else {
                status = 'scheduled';
            }
        }
        app.status = status;
        
        return {
          id: app.id,
          title: `${app.patient_details?.first_name || app.patient_name || 'Paciente'} ${app.patient_details?.last_name || ''}`.trim(),
          start: startDate,
          end: endDate,
          resource: app,
        };
      }));
    } catch (e) { console.warn('No se pudieron cargar las citas:', e.message); setEvents([]); }
    finally { setLoading(false); }
  }, []);

  const fetchFormData = useCallback(async () => {
    try {
      const patRes = await api.get('/api/patients/?page_size=1000');
      setPatients(patRes.data?.results || patRes.data || []);
    } catch (e) { console.warn('Error cargando pacientes:', e.message); }

    try {
      const docRes = await api.get('/api/users/');
      const allUsers = docRes.data?.results || docRes.data || [];
      setDoctors(allUsers.filter(u => {
        const username = (u.username || '').toLowerCase();
        const email = (u.email || '').toLowerCase();
        const firstName = (u.first_name || '').toLowerCase();
        const lastName = (u.last_name || '').toLowerCase();
        
        return !username.includes('admin') && 
               !email.includes('admin') && 
               !firstName.includes('admin') && 
               !lastName.includes('admin');
      }));
    } catch (e) { console.warn('Error cargando doctores:', e.message); }

    try {
      const treatRes = await api.get('/api/treatments/?limit=1000');
      setTreatments(treatRes.data?.results || treatRes.data || []);
    } catch (e) { console.warn('Tratamientos no disponibles:', e.message); }

    try {
      const cieRes = await api.get('/api/clinical-records/cie-codes/?limit=1000');
      setCieCodes(cieRes.data?.results || cieRes.data || []);
    } catch (e) { console.warn('Error cargando CIE-10:', e.message); }

    try {
      const [d, c, p, pr] = await Promise.all([
        getClinicalTerms('diagnosis'),
        getClinicalTerms('complication'),
        getClinicalTerms('prescription'),
        getClinicalTerms('procedure')
      ]);
      setDiagTerms(d);
      setCompTerms(c);
      setPrescTerms(p);
      setProcTerms(pr);
    } catch (e) {
      console.warn('Error cargando términos clínicos:', e.message);
    }
  }, []);

  useEffect(() => { fetchAppointments(); fetchFormData(); }, [fetchAppointments, fetchFormData]);

  // Autofill Phase 12 fields based on patient's latest clinical record
  useEffect(() => {
    if (!patientId) return;
    const fetchPatientRecord = async () => {
      try {
        const res = await api.get(`/api/clinical-records/?patient=${patientId}&ordering=-created_at&limit=1`);
        const records = res.data?.results || res.data || [];
        if (records.length > 0) {
          const r = records[0];
          if (r.diagnoses && r.diagnoses.length > 0) {
             setDiagnosisDesc(r.diagnoses[0].description || '');
             setDiagnosisCie(r.diagnoses[0].cie || '');
          }
          if (r.treatments && r.treatments.length > 0) {
             setComplications(r.treatments[0].complications || '');
          }
          if (r.prescription) setPrescriptions(r.prescription);
          if (r.signature) setSignatureId(r.signature);
        }
      } catch (e) {
        console.warn('Error fetching patient record', e);
      }
    };
    fetchPatientRecord();
  }, [patientId]);

  /* ── Handlers cita ── */
  const handleSelectSlot = useCallback((slotInfo) => {
    let sTime = slotInfo.start;
    let eTime = slotInfo.end;
    if (moment(sTime).isSame(eTime)) eTime = moment(sTime).add(1, 'hour').toDate();
    setAppointmentDate(moment(sTime).format('YYYY-MM-DD'));
    setAppointmentStartTime(moment(sTime).format('HH:mm'));
    setAppointmentEndTime(moment(eTime).format('HH:mm'));
    setPatientId(''); setNotes(''); setAdvancePayment(0);
    setServiceSearchQuery('');
    setBusquedaPaciente('');
    setMostrarListaPacientes(false);
    setNewPatientData({ first_name: '', last_name: '', email: '', phone: '', cedula: '', is_clinical: true, reason_for_consultation: '""' });
    setDiagnosisDesc(''); setDiagnosisCie(''); setComplications(''); setPrescriptions(''); setSignatureId('');
    setAppointmentServices([{ id: Date.now(), treatment_id: '', doctor_id: '', notes: '' }]);
    setShowModal(true);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const val = e.detail;
      handleSelectSlot({ start: val, end: moment(val).add(30, 'minutes').toDate() });
    };
    document.addEventListener('agenda-add-appointment', handler);
    return () => document.removeEventListener('agenda-add-appointment', handler);
  }, [handleSelectSlot]);

  const handleCloseModalCita = () => {
    setShowModal(false);
    setBusquedaPaciente('');
    setMostrarListaPacientes(false);
    setPatientId('');
    setNewPatientData({ first_name: '', last_name: '', email: '', phone: '', cedula: '', is_clinical: true, reason_for_consultation: '""' });
  };

  const handleSave = async () => {
    if (!patientId) { alert('Selecciona un paciente'); return; }
    if (!appointmentDate || !appointmentStartTime || !appointmentEndTime) { alert('Verifica la fecha y hora de la cita'); return; }
    setSaving(true);
    try {
      const validServices = appointmentServices.filter(s => s.doctor_id || s.notes);
      const servicesPayload = validServices.map(s => {
          return { 
              treatment: null, 
              name: 'Atención',
              price: 0,
              doctor: s.doctor_id || null, 
              notes: s.notes 
          };
      });
      const totalServicesPrice = servicesPayload.reduce((acc, s) => acc + s.price, 0);
      const clinicaBaseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const appRes = await api.post('/api/appointments/', {
        patient: patientId,
        date: appointmentDate,
        start_time: appointmentStartTime + ':00',
        end_time: appointmentEndTime + ':00',
        status: 'scheduled',
        notes,
        advance_payment: 0,
        services_data: servicesPayload,
      }, { baseURL: clinicaBaseURL });
      
      const newAppId = appRes.data?.id || appRes.data?.data?.id || appRes.data?.results?.id;

      // Actualizar balance del paciente: sumar la deuda de esta cita al saldo existente
      if (totalServicesPrice > 0) {
          try {
              const pRes = await api.get(`/api/patients/${patientId}/`, { baseURL: clinicaBaseURL });
              const currentBalance = parseFloat(pRes.data.balance || 0);
              const newDebt = totalServicesPrice;
              await api.patch(`/api/patients/${patientId}/`, { balance: currentBalance + newDebt }, { baseURL: clinicaBaseURL });
          } catch (e) { console.error('Error actualizando balance del paciente:', e); }
      }

      if (diagnosisDesc || diagnosisCie || complications || prescriptions || validServices.length > 0) {
          try {
              // Buscar historia clínica existente
              const crRes = await api.get(`/api/clinical-records/?patient=${patientId}`);
              let records = crRes.data?.results || crRes.data || [];
              if (Array.isArray(records)) {
                  records = records.filter(r => String(r.patient) === String(patientId) || (r.patient && String(r.patient.id) === String(patientId)));
              }
              const existingRecord = records.length > 0 ? records[0] : null;

              const newTreatmentRow = {
                  date: appointmentDate,
                  time: appointmentStartTime,
                  appointment_id: newAppId,
                  diagnostics_complications: (diagnosisDesc ? diagnosisDesc + (diagnosisCie ? ` (CIE: ${diagnosisCie})` : '') + '\n' : '') + (complications || ''),
                  procedures: validServices.map(s => s.notes || 'Atención').filter(Boolean).join(' | '),
                  prescriptions: prescriptions || '',
                  service_id: null,
                  code: ''
              };

              if (existingRecord) {
                  // A petición del usuario, Fase 12 (treatments) se desconecta de la agenda.
                  // No modificamos la historia existente desde la cita.
              } else {
                  // Crear nueva historia si no existe
                  await api.post('/api/clinical-records/', {
                      patient: patientId,
                      appointment: newAppId,
                      diagnoses: diagnosisDesc ? [{ description: diagnosisDesc, cie: diagnosisCie, type: 'DEF' }] : [{}, {}, {}, {}],
                      treatments: [], // Se inicializa vacío para llenarse manualmente
                      prescription: prescriptions
                  });
              }
          } catch (err) {
              console.warn('Error al guardar datos clínicos (Fase 12):', err.message);
          }
      }
      handleCloseModalCita();
      fetchAppointments();
    } catch (e) {
      console.error(e);
      const msg = e.response?.data ? Object.entries(e.response.data).map(([k,v]) => `${k}: ${v}`).join('\n') : 'Error al guardar la cita';
      alert(msg);
    } finally { setSaving(false); }
  };

  const handleCreatePatient = async () => {
    setSavingPatient(true);
    try {
      const res = await api.post('/api/patients/', newPatientData);
      const np = res.data;
      setPatients([np, ...patients]);
      setPatientId(np.id);
      const fullName = `${np.first_name || 'Paciente'} ${np.last_name || 'Anónimo'}`.trim();
      setBusquedaPaciente(fullName);
      setShowNewPatient(false);
      setNewPatientData({ first_name: '', last_name: '', email: '', phone: '', cedula: '', reason_for_consultation: '""', is_clinical: true });
    } catch (e) {
      let msg = 'Error al crear el paciente.';
      if (e.response?.data) { msg = Object.entries(e.response.data).map(([k,v]) => `${k}: ${v}`).join('\n'); }
      alert(msg);
    } finally { setSavingPatient(false); }
  };

  const handleUpdateStatus = async (newStatus) => {
    if (!selectedEvent?.id) return;
    try {
      await api.patch(`/api/appointments/${selectedEvent.id}/`, { status: newStatus });
      setSelectedEvent({ ...selectedEvent, resource: { ...selectedEvent.resource, status: newStatus } });
      fetchAppointments();
    } catch (e) {
      console.error(e);
      alert('Error al actualizar el estado.');
    }
  };

  const handleDeleteAppointment = async () => {
    if (!selectedEvent?.id) return;
    if (!window.confirm("¿Estás seguro de que deseas eliminar esta cita? Esta acción no se puede deshacer.")) return;
    try {
        await api.get(`/api/appointments/${selectedEvent.id}/`).then(async () => {
            const token = localStorage.getItem('token');
            await fetch(`${API_BASE}/api/appointments/${selectedEvent.id}/`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
            });
        });
        setShowEventDetails(false);
        fetchAppointments();
    } catch (e) {
        console.error(e);
        alert('Error al eliminar la cita.');
    }
  };

  const saveConfig = () => {
    setConfig(tempConfig);
    localStorage.setItem('agendaConfig', JSON.stringify(tempConfig));
    setShowConfig(false);
  };
  const toggleDay = (d) => {
    const days = tempConfig.visibleDays || [0,1,2,3,4,5,6];
    setTempConfig({ ...tempConfig, visibleDays: days.includes(d) ? days.filter(x => x !== d).sort() : [...days, d].sort() });
  };

  /* ── CSS días ocultos ── */
  const hiddenDaysCss = () => {
    const show = config.visibleDays || [0,1,2,3,4,5,6];
    const lines = [];
    [0,1,2,3,4,5,6].forEach(d => {
      if (!show.includes(d)) {
        const colIndex = d === 0 ? 7 : d;
        lines.push(`.rbc-time-view .rbc-time-header-content .rbc-header:nth-child(${colIndex}){display:none!important}`);
        lines.push(`.rbc-time-view .rbc-time-content .rbc-day-slot:nth-child(${colIndex + 1}){display:none!important}`);
      }
    });
    return lines.join('\n');
  };

  /* ── Event style ── */
  const eventStyleGetter = (event) => {
    const statusColor = STATUS_COLORS[event.resource?.status] || STATUS_COLORS.scheduled;
    return {
      style: {
        background: statusColor,
        border: 'none',
        borderRadius: '6px',
        color: '#ffffff',
        opacity: 1,
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        padding: '4px 6px',
      }
    };
  };

  /* ── Exportar a Imagen ── */
  const exportAgendaAsImage = () => {
    const exportContainer = document.getElementById('agenda-export-template');
    if (exportContainer) {
      html2canvas(exportContainer, { scale: 2, useCORS: true, backgroundColor: '#ffffff' }).then(canvas => {
        const link = document.createElement('a');
        link.download = `Agenda_Lemnardental_${moment(currentDate).format('YYYY_MM_DD')}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    }
  };

  /* ── Toolbar personalizado ── */
  const CustomToolbar = ({ date, onNavigate, view, onView, onConfigClick }) => {
    const monthYear = moment(date).format('MMMM [DE] YYYY').toUpperCase();
    const weekLabel = view === 'week' ? `Semana del ${moment(date).startOf('week').format('D/M/YYYY')}` :
                      view === 'day' ? moment(date).format('dddd, D MMMM') : '';
    return (
      <div className="agenda-toolbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        {/* Izquierda: mes + nav */}
        <div className="agenda-toolbar-left" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <div style={{ borderLeft: '3px solid #b87a00', paddingLeft: '8px' }}>
            <div style={{ fontSize: '14px', fontWeight: '800', color: '#111827', lineHeight: 1 }}>{monthYear}</div>
            <div style={{ fontSize: '9px', color: '#6b7280', fontWeight: '600', marginTop: '2px' }}>{weekLabel}</div>
          </div>

          <div className="view-buttons" style={{ display: 'flex', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
            {['year', 'month', 'week', 'day'].map((v) => (
              <button key={v} onClick={() => onView(v)} style={{
                padding: '4px 8px', border: 'none',
                background: view === v ? '#b87a00' : 'white',
                color: view === v ? 'white' : '#374151',
                borderRight: v !== 'day' ? '1px solid #e5e7eb' : 'none',
                cursor: 'pointer', fontSize: '11px', fontWeight: '600',
                transition: 'background 0.15s',
              }}>
                {v === 'year' ? 'Año' : v === 'month' ? 'Mes' : v === 'week' ? 'Semana' : 'Día'}
              </button>
            ))}
          </div>

          <div style={{ display: 'flex', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
            {[
              { label: '<', action: 'PREV' },
              { label: 'Hoy', action: 'TODAY' },
              { label: '>', action: 'NEXT' },
            ].map(({ label, action }) => (
              <button key={action} onClick={() => onNavigate(action)} style={{
                padding: '4px 10px', border: 'none',
                background: action === 'TODAY' ? '#f9fafb' : 'white',
                borderRight: action !== 'NEXT' ? '1px solid #e5e7eb' : 'none',
                cursor: 'pointer', fontSize: '11px', fontWeight: '600', color: '#374151',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.target.style.background = '#f3f4f6'}
              onMouseLeave={e => e.target.style.background = action === 'TODAY' ? '#f9fafb' : 'white'}
              >{label}</button>
            ))}
          </div>

          <button className="btn-nueva-cita" onClick={() => handleSelectSlot({ start: new Date(), end: moment().add(30, 'minutes').toDate() })}
            style={{ padding: '4px 10px', backgroundColor: '#b87a00', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 4px rgba(184, 122, 0, 0.3)' }}>
            <span>+</span> Cita
          </button>

          <button className="btn-exportar" onClick={exportAgendaAsImage}
            style={{ padding: '4px 8px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 4px rgba(16,185,129,0.3)' }}
            title="Exportar a Imagen">
            Exportar
          </button>

          <button className="btn-configurar-mobile" onClick={onConfigClick}
            style={{ padding: '4px 8px', backgroundColor: '#374151', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '11px', cursor: 'pointer', alignItems: 'center', gap: '6px' }}>
             Configurar Horario
          </button>
        </div>

        {/* Derecha: leyenda */}
        <div className="agenda-toolbar-right" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {[
            { key: 'scheduled',   label: 'PROGRAMADA' },
            { key: 'in_progress', label: 'EN PROCESO' },
            { key: 'completed',   label: 'COMPLETADA' },
            { key: 'cancelled',   label: 'CANCELADA' },
          ].map(({ key, label }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ width: 8, height: 8, borderRadius: '2px', backgroundColor: STATUS_COLORS[key], display: 'inline-block', flexShrink: 0 }} />
              <span style={{ fontSize: '9px', fontWeight: '700', color: '#6b7280', letterSpacing: '0.03em' }}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  /* ── Plantilla oculta para exportar ── */
  const AgendaExportTemplate = () => {
    const dayEvents = events.filter(e => moment(e.start).isSame(currentDate, 'day')).sort((a,b) => new Date(a.start) - new Date(b.start));
    return (
      <div id="agenda-export-template" style={{ position: 'absolute', top: '-9999px', left: '-9999px', width: '800px', backgroundColor: '#ffffff', padding: '40px', fontFamily: 'Inter, sans-serif', zIndex: -1 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #e5e7eb', paddingBottom: '20px', marginBottom: '20px' }}>
          <div>
            <h1 style={{ margin: 0, color: '#b87a00', fontSize: '28px' }}>Agenda Lemnardental</h1>
            <p style={{ margin: '5px 0 0', color: '#6b7280', fontSize: '16px' }}>{moment(currentDate).format('dddd, D [de] MMMM YYYY')}</p>
          </div>
        </div>
        {dayEvents.length === 0 ? (
          <p style={{ color: '#6b7280', fontSize: '18px', textAlign: 'center', margin: '40px 0' }}>No hay citas agendadas para este día.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {dayEvents.map((ev, index) => {
              const statusColor = STATUS_COLORS[ev.resource?.status] || STATUS_COLORS.scheduled;
              return (
                <div key={ev.id || index} style={{ display: 'flex', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden' }}>
                  <div style={{ width: '12px', background: statusColor, flexShrink: 0 }} />
                  <div style={{ padding: '20px', flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e5e7eb', paddingBottom: '12px', marginBottom: '12px' }}>
                      <div>
                        <div style={{ fontSize: '16px', color: '#b87a00', fontWeight: '800', marginBottom: '4px' }}>Cita {index + 1}</div>
                        <div style={{ fontSize: '15px', color: '#374151', fontWeight: '600' }}>
                          <span style={{ color: '#9ca3af', fontWeight: '700' }}>PACIENTE:</span> {ev.resource?.patient_details?.first_name || ev.title} {ev.resource?.patient_details?.last_name || ''}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ backgroundColor: statusColor, color: 'white', padding: '6px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold', display: 'inline-block', marginBottom: '6px' }}>
                          {STATUS_LABELS[ev.resource?.status] || 'Programado'}
                        </div>
                        <div style={{ fontSize: '14px', color: '#4b5563', fontWeight: '700' }}>
                          {moment(ev.start).format('HH:mm')} - {moment(ev.end).format('HH:mm')}
                        </div>
                      </div>
                    </div>
                    {ev.resource?.notes && <div style={{ fontSize: '13px', color: '#374151' }}>{ev.resource.notes}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div style={{ marginTop: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '12px' }}>Generado desde el sistema Lemnardental</div>
      </div>
    );
  };

  /* ════════════════ RENDER ════════════════ */
  return (
    <div className="main-agenda-container" style={{ height: '100vh', display: 'flex', flexDirection: 'column', padding: '12px', backgroundColor: '#ffffff', boxSizing: 'border-box' }}>
      <style>{AGENDA_CSS + '\n' + hiddenDaysCss()}</style>

      {/* ── Encabezado de página ── */}
      <div className="agenda-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
        <div>
          <h2 style={{ margin: 0, fontWeight: '800', fontSize: '18px', color: '#111827' }}>Agenda de Citas</h2>
          <p style={{ margin: '2px 0 0', color: '#9ca3af', fontSize: '11px' }}>Programación semanal y gestión de tiempos médicos.</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { setTempConfig(config); setShowConfig(true); }} style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '6px 12px', borderRadius: '6px', border: '1px solid #e5e7eb',
            background: 'white', color: '#374151', fontWeight: '600', fontSize: '11px',
            cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
          }}>
            <i className="bi bi-gear-fill" /> Configurar
          </button>
          <button onClick={() => handleSelectSlot({ start: new Date(), end: new Date() })} style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '6px 12px', borderRadius: '6px', border: 'none',
            background: '#b87a00',
            color: 'white', fontWeight: '700', fontSize: '11px',
            cursor: 'pointer', boxShadow: '0 4px 14px rgba(184,122,0,0.35)',
          }}>
            + Agendar Nueva Cita
          </button>
        </div>
      </div>

      {/* Plantilla oculta para exportar */}
      <AgendaExportTemplate />

      {/* ── Contenedor del calendario ── */}
      <div id="agenda-calendar-container" style={{
        flex: 1, background: 'white',
        borderRadius: isMobile ? '0' : '16px',
        padding: '10px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.05)',
        display: 'flex', flexDirection: 'column', minHeight: 0
      }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div style={{ textAlign: 'center', color: '#9ca3af' }}>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}></div>
              <p style={{ margin: 0 }}>Cargando agenda...</p>
            </div>
          </div>
        ) : (
          <>
            <CustomToolbar
              date={currentDate}
              view={currentView}
              onView={setCurrentView}
              onConfigClick={() => { setTempConfig(config); setShowConfig(true); }}
              onNavigate={(action) => {
                if (action === 'TODAY') { setCurrentDate(new Date()); return; }
                const amount = action === 'NEXT' ? 1 : -1;
                const unit = currentView === 'month' ? 'month' : currentView === 'year' ? 'year' : currentView === 'week' ? 'week' : 'day';
                setCurrentDate(moment(currentDate).add(amount, unit).toDate());
              }}
            />
            {currentView === 'year' ? (
              <YearView date={currentDate} onNavigate={setCurrentDate} onView={setCurrentView} events={events} />
            ) : (
              <Calendar
                localizer={localizer}
                events={events}
                step={30}
                timeslots={1}
                startAccessor="start"
                endAccessor="end"
                style={{ flex: 1 }}
                date={currentDate}
                onNavigate={setCurrentDate}
                view={currentView}
                onView={setCurrentView}
                views={['week', 'day', 'month']}
                min={new Date(2024, 0, 1, config.startHour, 0, 0)}
                max={new Date(2024, 0, 1, config.endHour, 59, 59)}
                onSelectSlot={handleSelectSlot}
                onSelectEvent={(ev) => { setSelectedEvent(ev); setShowEventDetails(true); }}
                selectable
                eventPropGetter={eventStyleGetter}
                components={{
                  event: CustomEvent,
                  week: { header: CustomDayHeader },
                  day:  { header: CustomDayHeader },
                  timeSlotWrapper: CustomTimeSlotWrapper,
                }}
                formats={{
                  eventTimeRangeFormat: () => null,
                  timeGutterFormat: (date, culture, loc) => loc.format(date, 'HH:mm', culture),
                }}
                messages={{ next: 'Sig', previous: 'Ant', today: 'Hoy', month: 'Mes', week: 'Semana', day: 'Día', agenda: 'Lista' }}
              />
            )}
          </>
        )}
      </div>

      {/* ════════ MODAL: NUEVA CITA ════════ */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px' }}>
          <div className="agenda-modal-container" style={{ background: 'white', borderRadius: '16px', width: '820px', maxWidth: '100%', maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            {/* Header */}
            <div className="agenda-modal-header" style={{ padding: '24px 28px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <h3 style={{ margin: 0, fontWeight: '800', color: '#111827' }}>Nueva Cita</h3>
              </div>
              <button onClick={handleCloseModalCita} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af', lineHeight: 1, padding: '4px' }}>✕</button>
            </div>

            <div className="agenda-modal-body" style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
              {/* Paciente */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <label style={{ fontWeight: '700', fontSize: '13px', color: '#374151' }}>Paciente *</label>
                  <div style={{ display: 'flex', gap: '8px' }}>

                    <button onClick={() => setShowNewPatient(true)} style={{ background: 'none', border: '1px solid #10b981', borderRadius: '6px', color: '#10b981', padding: '4px 10px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                      + Nuevo Paciente
                    </button>
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar paciente por nombre, cédula o teléfono..."
                    value={busquedaPaciente}
                    onChange={e => {
                      setBusquedaPaciente(e.target.value);
                      setMostrarListaPacientes(true);
                      if (patientId) setPatientId('');
                    }}
                    onFocus={() => setMostrarListaPacientes(true)}
                    style={{ borderRadius: '8px', borderColor: '#e5e7eb', fontSize: '13px' }}
                  />
                  {mostrarListaPacientes && busquedaPaciente && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', zIndex: 1000, maxHeight: '200px', overflowY: 'auto', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                      {filteredPatients.length > 0 ? filteredPatients.map(p => (
                        <div key={p.id} onClick={() => {
                          setPatientId(p.id);
                          setBusquedaPaciente(`${p.first_name || 'Paciente'} ${p.last_name || 'Anónimo'}`);
                          setMostrarListaPacientes(false);
                        }} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: '13px' }} onMouseEnter={e => e.target.style.backgroundColor = '#f3f4f6'} onMouseLeave={e => e.target.style.backgroundColor = 'transparent'}>
                          <div style={{ fontWeight: '600' }}>{p.first_name || 'Paciente'} {p.last_name || 'Anónimo'}</div>
                          <div style={{ fontSize: '11px', color: '#6b7280' }}>{p.cedula || 'Sin cédula'} | Tel: {p.phone || 'Sin teléfono'}</div>
                        </div>
                      )) : (
                        <div style={{ padding: '8px 12px', fontSize: '13px', color: '#6b7280' }}>No se encontraron pacientes...</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Notas */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ fontWeight: '700', fontSize: '13px', color: '#374151', display: 'block', marginBottom: '8px' }}>Notas Generales</label>
                <textarea className="form-control" rows={2} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Motivo de la consulta, síntomas..." style={{ borderRadius: '8px', borderColor: '#e5e7eb', fontSize: '13px' }} />
              </div>

              {/* Doctor */}
              <div style={{ marginBottom: '24px' }}>
                <h5 style={{ margin: 0, fontWeight: '700', color: '#374151', fontSize: '14px', marginBottom: '12px' }}>Doctor Asignado</h5>
                {appointmentServices.map((s) => (
                  <div key={s.id} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                    <div style={{ flex: 1 }}>
                      <select className="form-select" value={s.doctor_id} onChange={e => setAppointmentServices(appointmentServices.map(x => x.id === s.id ? { ...x, doctor_id: e.target.value } : x))} style={{ borderColor: '#e5e7eb', fontSize: '13px', borderRadius: '8px' }}>
                        <option value="">Sin asignar</option>
                        {doctors.map(d => <option key={d.id} value={d.id}>{d.first_name} {d.last_name}</option>)}
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>



            {/* Footer */}
            <div style={{ padding: '16px 28px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: '10px', flexShrink: 0 }}>
              <button onClick={handleCloseModalCita} disabled={saving} style={{ padding: '9px 22px', borderRadius: '9px', border: '1px solid #e5e7eb', background: 'white', color: '#374151', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>Salir</button>
              <button onClick={handleSave} disabled={saving} style={{ padding: '9px 24px', borderRadius: '9px', border: 'none', background: '#b87a00', color: 'white', fontWeight: '700', fontSize: '13px', cursor: 'pointer', boxShadow: '0 4px 14px rgba(184, 122, 0, 0.3)' }}>
                {saving ? 'Guardando...' : 'Guardar Cita'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════════ MODAL: NUEVO PACIENTE ════════ */}
      {showNewPatient && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1060, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '600px', maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <div style={{ padding: '24px 28px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, fontWeight: '800', color: '#111827' }}>Registrar Nuevo Paciente</h4>
              <button onClick={() => setShowNewPatient(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>
            <div style={{ padding: '24px 28px' }}>
              <div className="row g-3">
                {[
                  { label: 'Nombres', key: 'first_name', col: 6 },
                  { label: 'Apellidos', key: 'last_name', col: 6 },
                  { label: 'Teléfono', key: 'phone', col: 12 },
                  { label: 'Motivo de Consulta', key: 'reason_for_consultation', col: 12 },
                ].map(({ label, key, col, type = 'text' }) => (
                  <div key={key} className={`col-md-${col}`}>
                    <label style={{ fontWeight: '700', fontSize: '13px', color: '#374151', display: 'block', marginBottom: '6px' }}>{label}</label>
                    <input type={type} className="form-control" value={newPatientData[key] || ''} onChange={e => {
                      let val = e.target.value;
                      if (key === 'reason_for_consultation') {
                          val = val.replace(/"/g, '');
                          val = `"${val}"`;
                      }
                      setNewPatientData({ ...newPatientData, [key]: val });
                    }} style={{ borderRadius: '8px', borderColor: '#e5e7eb', fontSize: '13px' }} />
                  </div>
                ))}
                <div className="col-md-12 mt-2">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="checkIsClinical" checked={newPatientData.is_clinical !== false} onChange={e => setNewPatientData({ ...newPatientData, is_clinical: e.target.checked })} />
                    <label className="form-check-label fw-bold text-muted small" htmlFor="checkIsClinical">
                      ¿Generar historial clínico? (Si se desmarca, no aparecerá en la lista principal de pacientes)
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ padding: '16px 28px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setShowNewPatient(false)} disabled={savingPatient} style={{ padding: '9px 22px', borderRadius: '9px', border: '1px solid #e5e7eb', background: 'white', color: '#374151', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleCreatePatient} disabled={savingPatient} style={{ padding: '9px 24px', borderRadius: '9px', border: 'none', background: '#10b981', color: 'white', fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}>
                {savingPatient ? 'Guardando...' : 'Guardar y Seleccionar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════════ MODAL: DETALLES CITA ════════ */}
      {showEventDetails && selectedEvent && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '560px', maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <div style={{ padding: '24px 28px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, fontWeight: '800', color: '#111827' }}>Detalles de la Cita</h4>
              <button onClick={() => setShowEventDetails(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>
            <div style={{ padding: '24px 28px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '20px' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Paciente</div>
                  <div style={{ fontWeight: '600', color: '#111827' }}>{selectedEvent.resource?.patient_details?.first_name || selectedEvent.title} {selectedEvent.resource?.patient_details?.last_name || ''}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Horario</div>
                  <div style={{ fontWeight: '600', color: '#111827' }}>{moment(selectedEvent.start).format('ddd D MMM, HH:mm')} – {moment(selectedEvent.end).format('HH:mm')}</div>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '8px' }}>Estado</div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    {[
                      { key: 'scheduled', label: 'Programada' },
                      { key: 'in_progress', label: 'En Proceso' },
                      { key: 'completed', label: 'Completada' },
                      { key: 'cancelled', label: 'Cancelada' }
                    ].map(st => {
                      const isActive = selectedEvent.resource?.status === st.key;
                      return (
                        <button key={st.key} onClick={() => handleUpdateStatus(st.key)} style={{
                          padding: '5px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '700',
                          border: isActive ? 'none' : `1px solid ${STATUS_COLORS[st.key]}`,
                          background: isActive ? STATUS_COLORS[st.key] : 'white',
                          color: isActive ? 'white' : STATUS_COLORS[st.key],
                          cursor: 'pointer',
                        }}>{st.label}</button>
                      );
                    })}
                  </div>
                </div>
                {selectedEvent.resource?.notes && (
                  <div style={{ gridColumn: '1 / -1' }}>
                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Notas Generales</div>
                    <div style={{ color: '#374151', fontSize: '13px' }}>{selectedEvent.resource.notes}</div>
                  </div>
                )}
                {eventClinicalData && (
                  <>
                    {eventClinicalData.diagnostics_complications && (
                        <div style={{ gridColumn: '1 / -1' }}>
                          <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Diagnóstico / Complicaciones / CIE</div>
                          <div style={{ color: '#374151', fontSize: '13px', whiteSpace: 'pre-wrap' }}>{eventClinicalData.diagnostics_complications}</div>
                        </div>
                    )}
                    {eventClinicalData.prescriptions && (
                        <div style={{ gridColumn: '1 / -1' }}>
                          <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Prescripciones / Recetas</div>
                          <div style={{ color: '#374151', fontSize: '13px', whiteSpace: 'pre-wrap' }}>{eventClinicalData.prescriptions}</div>
                        </div>
                    )}
                  </>
                )}
                {selectedEvent.resource?.services_data?.length > 0 && (
                  <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', marginBottom: '4px' }}>Servicios / Tratamientos</div>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {selectedEvent.resource.services_data.map((srv, idx) => (
                        <li key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f3f4f6', fontSize: '13px', color: '#374151' }}>
                          <span>{srv.name} {srv.notes && <span style={{ color: '#9ca3af', fontSize: '11px' }}>({srv.notes})</span>}</span>
                          <strong style={{ color: '#111827' }}>${parseFloat(srv.price || 0).toFixed(2)}</strong>
                        </li>
                      ))}
                    </ul>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', paddingRight: '0', fontSize: '14px', fontWeight: '800', color: '#111827' }}>
                        <span>Subtotal Servicios:</span>
                        <span>${selectedEvent.resource.services_data.reduce((acc, s) => acc + parseFloat(s.price || 0), 0).toFixed(2)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div style={{ padding: '16px 28px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={handleDeleteAppointment} style={{ padding: '9px 22px', borderRadius: '9px', border: '1px solid #ef4444', background: '#fef2f2', color: '#ef4444', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>
                <i className="bi bi-trash3 me-2"></i>Eliminar Cita
              </button>
              <button onClick={() => setShowEventDetails(false)} style={{ padding: '9px 22px', borderRadius: '9px', border: '1px solid #e5e7eb', background: 'white', color: '#374151', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* ════════ MODAL: CONFIGURACIÓN ════════ */}
      {showConfig && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '480px', maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <div style={{ padding: '24px 28px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, fontWeight: '800', color: '#111827' }}> Configuración de Agenda</h4>
              <button onClick={() => setShowConfig(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>
            <div style={{ padding: '24px 28px' }}>
              <div style={{ marginBottom: '24px' }}>
                <label style={{ fontWeight: '700', fontSize: '13px', color: '#374151', display: 'block', marginBottom: '12px' }}>Días Visibles</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'].map((name, i) => {
                    const on = (tempConfig.visibleDays || [0,1,2,3,4,5,6]).includes(i);
                    return (
                      <button key={i} onClick={() => toggleDay(i)} style={{
                        padding: '7px 14px', borderRadius: '20px', border: `1px solid ${on ? '#b87a00' : '#e5e7eb'}`,
                        background: on ? '#b87a00' : 'white', color: on ? 'white' : '#6b7280',
                        fontWeight: '700', fontSize: '12px', cursor: 'pointer', transition: 'all 0.15s',
                      }}>{name}</button>
                    );
                  })}
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                {[
                  { label: 'Hora de Inicio', key: 'startHour' },
                  { label: 'Hora de Fin', key: 'endHour' },
                ].map(({ label, key }) => (
                  <div key={key}>
                    <label style={{ fontWeight: '700', fontSize: '13px', color: '#374151', display: 'block', marginBottom: '6px' }}>{label}</label>
                    <select className="form-select" value={tempConfig[key]} onChange={e => setTempConfig({ ...tempConfig, [key]: parseInt(e.target.value) })} style={{ borderRadius: '8px', borderColor: '#e5e7eb', fontSize: '13px' }}>
                      {[...Array(24).keys()].map(h => <option key={h} value={h}>{String(h).padStart(2,'0')}:00</option>)}
                    </select>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ padding: '16px 28px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setShowConfig(false)} style={{ padding: '9px 22px', borderRadius: '9px', border: '1px solid #e5e7eb', background: 'white', color: '#374151', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={saveConfig} style={{ padding: '9px 24px', borderRadius: '9px', border: 'none', background: '#b87a00', color: 'white', fontWeight: '700', fontSize: '13px', cursor: 'pointer', boxShadow: '0 4px 14px rgba(184, 122, 0, 0.3)' }}>Guardar Preferencias</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Agenda;
